var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36.068px",
    height: "36.068px",
    viewBox: "19.331 24.326 36.068 36.068",
    enableBackground: "new 19.331 24.326 36.068 36.068",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M52.66,60.395h-1.826c-0.082-0.063-0.158-0.129-0.246-0.184c-0.479-0.299-1.028-0.521-1.428-0.904 c-1.543-1.481-3.041-3.016-4.553-4.531c-1.063-1.065-2.123-2.135-3.188-3.207c-0.195,0.106-0.359,0.199-0.525,0.285 c-3.425,1.808-7.039,2.319-10.748,1.224c-6.019-1.785-9.563-5.862-10.67-12.05c-0.013-0.069-0.095-0.125-0.145-0.188v-3.73 c0.052-0.099,0.138-0.192,0.151-0.295c0.964-6.403,5.981-11.403,12.385-12.342c0.111-0.017,0.216-0.097,0.324-0.147h3.576 c0.269,0.078,0.532,0.178,0.807,0.228c9.014,1.634,14.333,11.039,11.07,19.598c-0.295,0.773-0.681,1.513-1.045,2.313 c0.034,0.024,0.095,0.052,0.14,0.097c2.483,2.48,4.966,4.965,7.452,7.442c0.476,0.476,0.85,1.004,1.05,1.649 c0.022,0.068,0.104,0.117,0.158,0.176v1.826c-0.059,0.063-0.143,0.119-0.169,0.195c-0.415,1.168-1.196,1.965-2.373,2.371 C52.781,60.25,52.725,60.336,52.66,60.395 M44.952,38.976c-0.017-6.088-4.921-10.998-10.979-10.992 c-6.086,0.007-10.996,4.935-10.983,11.028c0.013,6.02,4.956,10.954,10.959,10.939C40.033,49.936,44.967,45.014,44.952,38.976"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.fb60ef8f644378d898e8a94c74cc1a9c.svg";
export { ForwardRef as ReactComponent };